import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import RadioInputLabel from './elements/RadioInputLabel';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      depositAmount: '',
      usResident: undefined,
      creditScore: 650,
      loading: true,
      quoteAmount: null,
    };
  }

  _inputOnChange = (event) => {
    console.log('Setting', event.target.name, event.target.value)
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  _startQuote = async (event) => {
    const {
      email,
      name,
      phone,
      propertyAddress,
    } = this.state;

    this._stepOnSubmit(event, false);

    await fetch('https://api.mylighthouse.co/insurance/quote', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        name: name,
        phone: phone,
        propertyAddress: propertyAddress,
      })
    });
  }

  _updateQuote = async (event) => {
    event.preventDefault();

    const {
      annualIncome,
      bestDescription,
      creditScore,
      depositAmount,
      email,
      firstTimeRenter,
      monthlyRent,
      name,
      nonUsBestDescription,
      phone,
      usResident,
      landlordEmail,
      landlordName,
      landlordPhone,
      propertyAddress,
      step,
    } = this.state;

    if (step === 7 && !landlordEmail && !landlordPhone) {
      alert('Please provide email address or phone number');
      return false;
    }

    this.setState({
      loading: true,
      quoteAmount: null,
    });

    const rawResponse = await fetch('https://api.mylighthouse.co/insurance/quote', {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        annualIncome: parseInt(annualIncome, 10),
        depositAmount: parseInt(depositAmount, 10),
        email: email,
        firstTimeRenter: firstTimeRenter === "1",
        bestDescription: bestDescription,
        monthlyRent: parseInt(monthlyRent, 10),
        name: name,
        nonUsBestDescription: nonUsBestDescription,
        phone: phone,
        usResident: usResident === "1",
        creditScore: creditScore,
        landlordEmail: landlordEmail,
        landlordName: landlordName,
        landlordPhone: landlordPhone,
        propertyAddress: propertyAddress,
      })
    });

    const content = await rawResponse.json();

    if (!content) {
      return;
    }

    this.setState({
      loading: false,
      submitted: true,
      quoteAmount: content,
    });
  }

  _stepOnSubmit = (event, updateQuote = true) => {
    event.preventDefault();

    const {
      firstTimeRenter,
      nonUsBestDescription,
      usResident,
    } = this.state;

    let step = parseInt(event.target.dataset.step, 10) + 1;

    if (step === 5 && ((usResident === "1" && firstTimeRenter === "1") || (usResident === "0" && nonUsBestDescription !== "currently-employed"))) {
      step++;
    }

    this.setState({
      step: step,
      loading: false,
      submitted: false,
    });

    if (updateQuote) {
      this._updateQuote(event);
    }

    return false;
  }

  _backOnClick = (event) => {
    let step = parseInt(event.target.dataset.step, 10) - 1;

    const {
      firstTimeRenter,
      nonUsBestDescription,
      usResident,
    } = this.state;

    if (step === 5 && ((usResident === "1" && firstTimeRenter === "1") || (usResident === "0" && nonUsBestDescription !== "currently-employed"))) {
      step--;
    }

    this.setState({
      step: step,
    });
  }

  render() {
    const {
      annualIncome,
      bestDescription,
      creditScore,
      depositAmount,
      loading,
      email,
      firstTimeRenter,
      landlordEmail,
      landlordName,
      landlordPhone,
      monthlyRent,
      name,
      nonUsBestDescription,
      propertyAddress,
      quoteAmount,
      step,
      submitted,
      usResident,
     } = this.state;

    return (
      <div>
        <header>
          <a href="https://mylighthouse.co" target="_blank" rel="noreferrer"><img alt="Lighthouse" src="/lighthouse.svg"/></a>
        </header>
        {step === 1 &&
          <div className="step">
            <h2>Let's start with your personal details</h2>
            <form data-step={step} onSubmit={this._startQuote}>
              <fieldset>
                <label>Your name *</label>
                <input className="input" type="text" name="name" value={name} onChange={this._inputOnChange} required={true} />
              </fieldset>
              <fieldset>
                <label>Email address *</label>
                <input className="input" type="email" name="email" value={email} onChange={this._inputOnChange} required={true} />
              </fieldset>
              <fieldset>
                <label>Full address you're moving to *</label>
                <input className="input" type="text" name="propertyAddress" value={propertyAddress} onChange={this._inputOnChange} required={true} />
              </fieldset>
              {usResident === "1" &&
                <fieldset style={{ display: 'none' }}>
                  <label>Credit score (for testing) *</label>
                  <input className="input" type="text" name="creditScore" value={creditScore} onChange={this._inputOnChange} required={true} />
                </fieldset>
              }
              <div className="prevnext">
                <button type="submit">Next</button>
              </div>
            </form>
          </div>
        }
        {step === 2 &&
          <div className="step">
            <h2>What's your security deposit amount?</h2>
            <form data-step={step} onSubmit={this._stepOnSubmit}>
              <fieldset>
                <CurrencyInput
                  required={true}
                  className="input"
                  name="depositAmount"
                  value={depositAmount}
                  prefix="$"
                  placeholder="Please enter a number"
                  decimalsLimit={0}
                  onValueChange={(value, name) => 
                    this._inputOnChange({
                      target: {
                        name: name,
                        value: value,
                      }
                    })
                  }
                />
              </fieldset>
              <div className="prevnext">
                <button data-step={step} onClick={this._backOnClick}>Back</button>
                <button type="submit">Next</button>
              </div>
            </form>
          </div>
        }
        {step === 3 &&
          <div className="step">
            <h2>Are you a US resident?</h2>
            <form data-step={step} onSubmit={this._stepOnSubmit}>
            <RadioInputLabel
                name="usResident"
                value={usResident}
                onChange={this._inputOnChange}
                options={[
                  { label: "Yes", value: "1" },
                  { label: "No", value: "0" },
                ]}
              />
              <div className="prevnext">
                <button data-step={step} onClick={this._backOnClick}>Back</button>
                <button type="submit" disabled={usResident === undefined}>Next</button>
              </div>
            </form>
          </div>
        }
        {step === 4 &&
          <div className="step">
            {usResident === "1" &&
              <div>
                <h2>Are you a first time renter?</h2>
                <form data-step={step} onSubmit={this._stepOnSubmit}>
                  <RadioInputLabel
                    name="firstTimeRenter"
                    value={firstTimeRenter}
                    onChange={this._inputOnChange}
                    options={[
                      { label: "Yes", value: "1" },
                      { label: "No", value: "0" },
                    ]}
                  />
                  <div className="prevnext">
                    <button data-step={step} onClick={this._backOnClick}>Back</button>
                    <button type="submit" disabled={firstTimeRenter === undefined}>Next</button>
                  </div>
                </form>
              </div>
            }
            {usResident === "0" &&
              <div>
                <h2>What best describes you?</h2>
                <form data-step={step} onSubmit={this._stepOnSubmit}>
                  <RadioInputLabel
                    name="nonUsBestDescription"
                    value={nonUsBestDescription}
                    onChange={this._inputOnChange}
                    options={[
                      { label: "Currently Employed", value: "currently-employed" },
                      { label: "Student", value: "student" },
                      { label: "Other", value: "other" },
                    ]}
                  />
                  <div className="prevnext">
                    <button data-step={step} onClick={this._backOnClick}>Back</button>
                    <button type="submit" disabled={nonUsBestDescription === undefined}>Next</button>
                  </div>
                </form>
              </div>
            }
          </div>
        }
        {step === 5 &&
          <div className="step">
            {usResident === "1" &&
              <div>
                <h2>What best describes you?</h2>
                <form data-step={step} onSubmit={this._stepOnSubmit}>
                  <RadioInputLabel
                    name="bestDescription"
                    value={bestDescription}
                    onChange={this._inputOnChange}
                    options={[
                      { label: "Self Employed", value: "self-employed" },
                      { label: "Student/Retired", value: "student-retired" },
                      { label: "Relocating from out of state", value: "relocating" },
                      { label: "Other", value: "other" },
                    ]}
                  />
                  <div className="prevnext">
                    <button data-step={step} onClick={this._backOnClick}>Back</button>
                    <button type="submit" disabled={bestDescription === undefined}>Submit</button>
                  </div>
                </form>
              </div>
            }
            {usResident === "0" &&
              <div>
                <h2>We need some financial info to calculate your monthly price</h2>
                <form data-step={step} onSubmit={this._stepOnSubmit}>
                  <fieldset>
                    <label>Annual income *</label>
                    <CurrencyInput
                      required={true}
                      className="input"
                      name="annualIncome"
                      value={annualIncome}
                      prefix="$"
                      placeholder="Please enter a number"
                      decimalsLimit={0}
                      onValueChange={(value, name) => 
                        this._inputOnChange({
                          target: {
                            name: name,
                            value: value,
                          }
                        })
                      }
                    />
                  </fieldset>
                  <fieldset>
                    <label>Monthly rent *</label>
                    <CurrencyInput
                      required={true}
                      className="input"
                      name="monthlyRent"
                      value={monthlyRent}
                      prefix="$"
                      placeholder="Please enter a number"
                      decimalsLimit={0}
                      onValueChange={(value, name) => 
                        this._inputOnChange({
                          target: {
                            name: name,
                            value: value,
                          }
                        })
                      }
                    />
                  </fieldset>
                  <div className="prevnext">
                    <button data-step={step} onClick={this._backOnClick}>Back</button>
                    <button type="submit" disabled={annualIncome === undefined || monthlyRent === undefined}>Submit</button>
                  </div>
                </form>
              </div>
              }
          </div>
        }
        {step === 6 &&
          <div className="step">
            <h2>Your quote</h2>
            <p>Based on the information provided your monthly rate would be around:</p>
            {loading &&
              <p><strong>Please wait...</strong></p>
            }
            {quoteAmount &&
              <>
                <h3 className="amount">${quoteAmount}/month</h3>
                <div className="info">* Pricing is subject to change during final quote</div>
              </>
            }
            <div className="prevnext">
              <button data-step="6" onClick={this._backOnClick}>Back</button>
              <button data-step="6" onClick={(event) => {
               this._stepOnSubmit(event, false);
              }} disabled={loading}>Let’s get your landlord’s approval</button>
            </div>
          </div>
        }
        {step === 7 &&
          <div className="step">
            {submitted ? (
              <>
                <h2>Thanks for choosing Lighthouse!</h2>
                <p>We’ve got some work to do on your behalf. We’ll be back in touch soon!</p>
                <div className="info">* Security deposit coverage is not available in all states</div>
              </>) : (
                <h2>Who is your landlord? We'll contact them to help you save money.</h2>
              )
            }
            {loading &&
              <p>Please wait...</p>
            }
            {!loading && !submitted &&
              <form data-step="5" onSubmit={this._updateQuote}>
                <fieldset>
                  <label>Your landlord's name *</label>
                  <input className="input" type="text" name="landlordName" value={landlordName} onChange={this._inputOnChange} required={true} />
                </fieldset>
                <fieldset>
                  <label>Email address</label>
                  <input className="input" type="email" name="landlordEmail" value={landlordEmail} onChange={this._inputOnChange} />
                </fieldset>
                <fieldset>
                  <label>Phone number</label>
                  <input className="input" type="text" name="landlordPhone" value={landlordPhone} onChange={this._inputOnChange} />
                </fieldset>
                <div className="prevnext">
                  <button data-step="7" onClick={this._backOnClick}>Back</button>
                  <button type="submit">Submit</button>
                </div>
              </form>
            }
          </div>
        }
      </div>
    );
  }
}

export default App;
